import { Theme } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import { withStyles } from '../utility/styles';
import InfoPanelTimeOffRequestView from './InfoPanelTimeOffRequestView';
import { dialogInfoPanelTimeOffRequestViewModel, ITimeOffDetailFields } from './InfoPanelTimeOffRequestViewModel';
import timeOffDialogModel, { ITimeOffDetailRow } from './TimeOffDialogModel';

const detailRowStyles = (_theme: Theme) => ({
  root: {
    width: '100%',
    margin: '0px !important',
    gridTemplateColumns: 'repeat(auto-fit, minmax(40px, 1fr))',
    gridGap: '8px',
  },
});

interface IDetailRowProps {
  classes?: any;
  detailRow: ITimeOffDetailRow;
}

// type DetailRowProps = WithStyle<ReturnType<typeof detailRowStyles>, IDetailRowProps>;

export const DetailRow = withStyles<IDetailRowProps>(
  detailRowStyles,
  class extends React.PureComponent<IDetailRowProps> {
    constructor(props: IDetailRowProps) {
      super(props);
    }

    render() {
      const { classes, detailRow } = this.props;

      return (
        <Observe
          render={() => (
            <div className={classNames('content', classes.root)}>
              {Object.keys(detailRow.data).map((detailName: keyof ITimeOffDetailFields) => {
                const detailField = detailRow.data[detailName];
                return <detailField.field.Editor key={detailField.field.name} className={`span${detailField.columns}`} />;
              })}
            </div>
          )}
        />
      );
    }
  },
);

const styles = (theme: Theme) => ({
  content: {
    padding: '10px 20px 0px 20px',
    overflowY: 'auto',
  },
  fieldContainer: {
    width: '100%',
    display: 'flex',
    marginBottom: '15px',
    '& > div': {
      display: 'flex',
      flex: '1',
      '&:not(:last-child)': {
        marginRight: '20px',
      },
    },
  },
  removeDetailButton: {
    marginTop: '0.4em',
    marginRight: '10px',
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
  detailHeader: {},
  detailsContainer: {
    paddingTop: '10px',
    margin: '5px 0px 25px 0px',
    maxHeight: '230px',
    overflowY: 'auto',
  },
  detailRoot: {
    width: '100%',
  },
  detail: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '1em',
    '&:last-child': {
      marginBottom: '0px',
    },
  },
  detailRow: {},
  detailRowsMessage: {
    color: theme.palette.error.main,
    marginLeft: '10px',
    fontSize: '0.8em',
  },
});

interface ITimeOffDialogProps {}

type TimeOffDialogProps = WithStyle<ReturnType<typeof styles>, ITimeOffDialogProps>;

class TimeOffDialog extends React.PureComponent<TimeOffDialogProps> {
  constructor(props: TimeOffDialogProps) {
    super(props);
  }

  render() {
    return (
      <DraggableResizableDialog
        defaultWidth="sm"
        DialogProps={{ dialog: timeOffDialogModel }}
        DraggableResizableBoxProps={{ minWidth: '60vh', minHeight: '90vh', maxHeight: '90vh', overflowY: 'auto' }}
      >
        <InfoPanelTimeOffRequestView model={dialogInfoPanelTimeOffRequestViewModel} hideActions={true} />
      </DraggableResizableDialog>
    );
  }
}

export default withStyles(styles, TimeOffDialog);
